
// eslint-disable @typescript-eslint/no-explicit-any
import Vue from "vue";
export default Vue.extend({
  created() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  },
  methods: {
    login() {
      console.log("login");
    },
  },
});
